import { useState } from "react";
import { useTheme } from "../context/ThemeContext";
import { Palette } from "lucide-react";
import ThemeCustomizerDrawer from "./ThemeCustomizerDrawer";

export default function ThemeSwitcher() {
  const { theme, themes } = useTheme();
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="relative" data-testid="theme-switcher">
      <button
        id="openThemeEditor"
        onClick={() => setDrawerOpen(true)}
        className="w-8 h-8 rounded-[4px] flex items-center justify-center bg-white/[0.03] hover:bg-white/[0.08] border border-white/10 hover:border-[var(--tf-primary)]/50 transition-all duration-200 hover:scale-105 cursor-pointer"
        title="Personalizare Temă & Fundal"
        data-testid="theme-switcher-btn"
      >
        <Palette className="w-3.5 h-3.5" style={{ color: themes[theme]?.primary || "var(--tf-primary)" }} />
      </button>

      <ThemeCustomizerDrawer 
        isOpen={drawerOpen} 
        onClose={() => setDrawerOpen(false)} 
      />
    </div>
  );
}
